module.exports = __webpack_public_path__ + "static/media/fire.838250c2.svg";